import config from 'services/table/const';
import { formatDate, currencyFormat } from 'utilities/common';
import Action from './action';

let table = { ...config };
table.url = '/wms/fulfillment';
table.columns = {
  code: {
    title: 'Kode',
    alias: 'delivery_plan.code',
    sortable: true,
    width: 130,
    component: (row) => {
      return (
        <div className="table-col">
          <div className="text-ellipsis fs-8 fw-semibold text-uppercase">
            {row?.delivery_plan?.code}
          </div>
          {row?.delivery_plan?.ref_code && (
            <small className="info">REF: {row?.delivery_plan?.ref_code}</small>
          )}
        </div>
      );
    },
  },

  recipient_name: {
    title: 'Nama Penerima',
    sortable: true,
    alias: 'delivery_plan.recipient.recipient_name',
    width: 150,
    component: (row) => {
      return (
        <div className="table-col">
          <div className="fs-8 fw-semibold">{row?.delivery_plan?.recipient_name}</div>
          <small className="info text-uppercase text-ellipsis">
            {row?.delivery_plan?.recipient_region
              ? `${row?.delivery_plan?.recipient_region?.district_name}, ${row?.delivery_plan?.recipient_region?.regency_name}, ${row?.recipient_region?.delivery_plan?.province_name}`
              : null}
          </small>
        </div>
      );
    },
  },

  schedule_at: {
    title: 'Tanggal Pengiriman',
    sortable: true,
    class: 'text-center',
    classHeader: 'text-center',
    width: 100,
    component: (row) => {
      return <div>{formatDate(row?.delivery_plan?.shipping_date, 'DD/MM/YYYY')}</div>;
    },
  },

  fulfill_by: {
    title: 'Pengerjaan oleh',
    sortable: true,
    width: 150,
    component: (row) => {
      return (
        <div className="table-col">
          <div className="text-ellipsis fs-8 fw-semibold text-uppercase">
            {row?.fulfill_by}
          </div>
          <small className="info text-uppercase">
            {formatDate(row?.fulfill_at)}
          </small>
        </div>
      );
    },
  },

  checked_by: {
    title: 'Pengecekan oleh',
    sortable: true,
    width: 150,
    component: (row) => {
      return (
        row?.checked_by !== '' ? (
          <div className="table-col">
            <div className="text-ellipsis fs-8 fw-semibold text-uppercase">
              {row?.checked_by}
            </div>
            <small className="info text-uppercase">
              {formatDate(row?.checked_at)}
            </small>
          </div>
        ) : <span>-</span>
      );
    },
  },

  total_weight: {
    title: 'Total Berat',
    sortable: false,
    width: 80,
    class: 'text-end',
    classHeader: 'text-end',
    component: (row) => {
      return (
        <span>{currencyFormat(row?.total_weight / 1000)} Kg </span>
      );
    },
  },

  document_status: {
    title: 'Status',
    sortable: true,
    class: 'text-center',
    classHeader: 'text-center',
    width: 80,
    component: (row) => {
      return (
        <span className={`badge status-${row?.document_status}-lt ms-auto `}>
          {row?.document_status?.replace('_', ' ')?.replace('voided', 'void')}
        </span>
      );
    },
  },

  action: {
    title: '',
    width: 40,
    class: 'text-end',
    component: (row) => {
      return <Action data={row} />;
    },
  },
};
export default table;
